'use strict';

(function () {
  'use strict';

  angular.module('vnext').config(vNextConfig);

  vNextConfig.$inject = ['$stateProvider', 'errorRouterProvider', 'InspirationDetailRouterProvider'];

  function vNextConfig($stateProvider, errorRouterProvider, InspirationDetailRouterProvider) {

    init();

    function init() {
      _registerBaseRoutes();
      _registerLogoutRoute();
      _registerHomepage();
      _registerErrorRoutes();
      _registerRoutes();
    }

    function _registerBaseRoutes() {
      $stateProvider.state('vnext', {
        url: '/',
        abstract: true,
        default: '.content',
        data: {
          pageTitle: 'pageTitles.vnext'
        },
        views: {
          'main': {
            templateUrl: 'vnext/pages/vnext.html',
            controller: 'VNextCtrl',
            controllerAs: 'nav',
            resolve: {
              user: ['userSvc', function (userSvc) {
                return userSvc.getUser();
              }]
            }
          }
        },
        resolve: {
          translateReady: ['$translate', function ($translate) {
            return $translate.onReady();
          }]
        }
      }).state('vnext.content', {
        url: '',
        abstract: true,
        default: '.homepage',
        views: {
          'content': {
            template: '<div ui-view></div>'
          }
        }
      }).state('vnext.logout', {
        url: 'logout',
        views: {
          'content': {
            template: '',
            controller: 'logoutCtrl',
            controllerAs: 'vm'
          }
        }
      });
    }

    function _registerLogoutRoute() {
      $stateProvider.state('logout', {
        url: '/logout',
        templateUrl: 'core/pages/logout.html',
        controller: 'logoutCtrl'
      });
    }

    function _registerErrorRoute(route) {
      if (route.name === 'vnext.content.error') {
        //HACK - drop the / from the error URLs for some dumb reason
        route.url = route.url.substring(1, route.url.length);
        route.templateUrl = 'vnext/pages/error/error.html';
      }
      $stateProvider.state(route.name, route);
    }

    function _registerErrorRoutes() {
      var errorRoutes = errorRouterProvider.buildRoutes('vnext.content');
      //wire the routes
      for (var index in errorRoutes) {
        if (errorRoutes.hasOwnProperty(index)) {
          var route = errorRoutes[index];
          if (route.hasOwnProperty('name')) {
            _registerErrorRoute(route);
          }
        }
      }
    }

    function _registerHomepage() {
      var homepageBaseStateName = 'vnext.content.homepage';
      var homepageInspirationStates = InspirationDetailRouterProvider.buildRoutes(homepageBaseStateName);
      // Since the homepage url ends with an extra '/', unlike the rest of the routes,
      // we need to pop the first '/' off the url of the detail state.
      homepageInspirationStates.detail.url = homepageInspirationStates.detail.url.substring(1);
      $stateProvider.state(homepageBaseStateName, {
        url: '',
        data: {
          pageTitle: 'pageTitles.home'
        },
        resolve: {
          appMode: ['userSvc', function (userSvc) {
            return userSvc.getUser().then(function (user) {
              return user && user.accessCode && user.accessCode.applicationMode ? user.accessCode.applicationMode.name : 'STANDARD';
            });
          }]
        },
        templateUrl: 'vnext/pages/homepage/homepage.html',
        controller: 'HomepageCtrl',
        controllerAs: 'vm'
      }).state(homepageInspirationStates.modal).state(homepageInspirationStates.detail);
    }

    function _registerRoutes() {
      $stateProvider.state('vnext.content.styleguide', {
        url: 'styleguide',
        data: {
          pageTitle: 'pageTitles.vnext'
        },
        templateUrl: 'vnext/pages/styleguide/styleguide.html',
        controller: 'StyleguideCtrl',
        controllerAs: 'vm'
      }).state('vnext.content.help', {
        url: 'help',
        templateUrl: 'vnext/pages/help/help.html',
        controller: 'GetHelpCtrl',
        controllerAs: 'vm',
        data: {
          pageTitle: 'pageTitles.help'
        }
      }).state('vnext.content.tools', {
        url: 'tools',
        templateUrl: 'vnext/pages/tools/tools.html',
        controller: 'ToolsCtrl',
        controllerAs: 'vm',
        data: {
          pageTitle: 'pageTitles.tools'
        },
        resolve: {
          appMode: ['userSvc', function (userSvc) {
            return userSvc.getUser().then(function (user) {
              return user && user.accessCode && user.accessCode.applicationMode ? user.accessCode.applicationMode.name : 'STANDARD';
            });
          }]
        }
      }).state('vnext.content.favorites', {
        url: 'favorites',
        templateUrl: 'vnext/pages/favorites/favorites.html',
        controller: 'FavoritesCtrl',
        controllerAs: 'vm',
        resolve: {
          favorites: ['librarySvc', function (librarySvc) {
            return librarySvc.get(true);
          }],
          inspirations: ['inspirationSvc', function (inspirationSvc) {
            return inspirationSvc.getType('favorited');
          }]
        },
        data: {
          pageTitle: 'pageTitles.favorites'
        },
        params: {
          disableInspirationBrowsing: true
        }
      }).state(InspirationDetailRouterProvider.buildRoutes('vnext.content.favorites').modal).state(InspirationDetailRouterProvider.buildRoutes('vnext.content.favorites').detail).state('vnext.content.history', {
        url: 'history',
        abstract: true,
        default: '.timeline',
        template: '<ui-view />',
        data: {
          pageTitle: 'pageTitles.history'
        }
      }).state('vnext.content.history.timeline', {
        url: '',
        templateUrl: 'vnext/pages/history/history.html',
        controller: 'HistoryCtrl',
        controllerAs: 'vm',
        resolve: {
          user: ['userSvc', function (userSvc) {
            return userSvc.getUser();
          }]
        },
        data: {
          pageTitle: 'pageTitles.history'
        }
      }).state('vnext.content.assessments', {
        url: 'assessments',
        templateUrl: 'vnext/pages/history/assessments.html',
        controller: 'AssessmentsCtrl',
        controllerAs: 'vm',
        resolve: {
          user: ['userSvc', function (userSvc) {
            return userSvc.getUser();
          }],
          assessmentResponses: ['$q', 'wellnessSvc', 'userSvc', function ($q, wellnessSvc, userSvc) {
            return userSvc.getUser().then(function (user) {
              if (user.assessmentResponseSummaries) {
                return wellnessSvc.getAssessmentResponses();
              } else {
                return $q.when([]);
              }
            });
          }],
          assessmentResponsesNested: ['$q', 'wellnessSvc', 'userSvc', function ($q, wellnessSvc, userSvc) {
            return userSvc.getUser().then(function (user) {
              if (user.assessmentResponseSummaries) {
                return wellnessSvc.getAssessmentResponsesNested();
              } else {
                return $q.when([]);
              }
            });
          }]
        },
        data: {
          pageTitle: 'pageTitles.assessments'
        }
      }).state('vnext.content.appFeedback', {
        url: 'feedback',
        templateUrl: 'vnext/pages/appFeedback/appFeedback.html',
        controller: 'AppFeedbackCtrl',
        controllerAs: 'vm',
        data: {
          pageTitle: 'pageTitles.appFeedback'
        }
      });
    }
  }
})();